<template>
  <div>
    <transition name="fade">
      <div class="img-view" @click="bigImg">
        <p class="img-layer"></p>
        <p class="img">
          <img :src="imgSrc" alt />
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    bigImg() {
      this.$emit("clickit");
    }
  },
  props: {
    imgSrc: {
      type: String
    }
  }
};
</script>

<style scoped >
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s linear;
  transform: translate3D(0, 0, 0);
}
.fade-enter,
.fade-leave-active {
  transform: translate3D(100%, 0, 0);
}
.img-view {
  position: inherit;
  width: 100%;
  height: 100%;
}
.img-view .img-layer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.img-view .img img {
  max-width: 100%;
  max-height: 10rem;
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
  margin: auto;
  z-index: 1000;
}
</style>





